import { FC } from "react";

export const MediaPlayer: FC = () => {
	return (<>
		<div style={{ display: "flex", position: "relative", flex: "1 1 auto", flexDirection: "row", flexWrap: "nowrap" }}>
			<div style={{ display: "flex", flex: "1 1 auto", flexDirection: "column", flexWrap: "nowrap" }} id="container"></div>
		</div>
		<canvas id="canvasContainer" style={{ width: "1280px", height: "720px" }}></canvas>
	</>);
}
